const theme = {
  colors: {
    primary: '#111827',
    secondary: '#4B5563',
    accent: '#3B82F6',
    background: '#FFFFFF',
    text: '#111827',
    border: '#E5E7EB',
  },
  fonts: {
    sans: "'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    serif: "'Playfair Display', Georgia, serif",
  },
  sizes: {
    maxWidth: '80rem', // 1280px
  },
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
  },
  transitions: {
    default: '0.2s ease',
    slow: '0.3s ease',
    fast: '0.1s ease',
  },
};

export default theme; 